export enum QuickDates {
    CurrentVoyage = "Current voyage",
    Hours_12 = "12 hours",
    Day_1 = "1 day",
    Day_3 = "3 days",
    Month_1 = "1 month"
}

export enum DateType {
    fromDate = "fromDate",
    toDate = "toDate"
}